import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'logged_out_retailers-deep_link_blog-click';

/**
 * This event tracks when a logged out user clicks on the deep-linked blog categories (on mobile or desktop)
 */
export function trackLoggedOutRetailersDeepLinkBlogClick(
  blog_category: string,
  origin2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { blog_category, origin2 },
  });
}
